import { TFunction } from "next-i18next"
import { Document } from "../../api-clients/assets-api"
import { ArticleModel, DocumentModel, ProductModel, VideoModel } from "../../api-clients/product-api-v1"

export const getArchivedArticleProductData = (product: ProductModel, articleId: string) => {
  // Check if the product has active articles
  const isProductActive = !!product.articles?.articlesList?.find((article) => !article.state?.archived)

  /* Filter articles by articleId */
  const article = product.articles?.articlesList?.find((article) => article.key === articleId) as ArticleModel

  const articles = {
    articlesList: [article],
    attributesList: product.articles?.attributesList,
    articlesListSize: 1,
  }
  product.articles = articles

  return { product, isProductActive }
}

export const formatDocuments = (document: Document[], t: TFunction): DocumentModel[] => {
  return document?.map((document) => ({
    ...document,
    contentType: document.documentType,
    description: t?.(`assets-document-content-type-${document?.documentType?.toLowerCase()}`),
    explanation: document.title ?? "",
  })) as DocumentModel[]
}

export const getArchivedArticleDocumentsData = (articleDocuments, articleId: string, t: TFunction) => {
  const article = articleDocuments?.find((doc) => doc.id === articleId)
  return article?.documents ? formatDocuments(article?.documents, t) : []
}

export const formatVideos = (videos: { url?: string }[]) => {
  return videos?.map((video) => ({
    youtubeID: video?.url?.split("/").slice(-1),
  })) as VideoModel[]
}

export const getArchivedArticleVideoData = (
  articleVideos: { id: string; videos?: { url?: string }[] }[],
  articleId: string
): VideoModel[] => {
  const article = articleVideos?.find((doc) => doc.id === articleId)
  return article?.videos ? (formatVideos(article.videos) as VideoModel[]) : []
}
